module.exports = __webpack_public_path__ + "media/slide1/contractMediaSlide1Part3vs-fe1f8c39.png";